module.exports = __webpack_public_path__ + "img/quantum-seguranca-250x139.ddd8aa54.png";